<script setup lang="ts">
import type { CanvassTargetWithProgress } from "@/canvasses/types";
import { useSatisfiedCanvassTargets } from "./useSatisfiedCanvassTargets";

defineProps<{
  canvassTargets: Array<CanvassTargetWithProgress>;
}>();

const satisfiedCanvassTargetIds = defineModel<Array<string>>(
  "satisfiedCanvassTargetIds",
  { required: true },
);

const { toggleSatisfiedCanvassTarget, canvassTargetIsSatisfied } =
  useSatisfiedCanvassTargets(satisfiedCanvassTargetIds);
</script>
<template>
  <fieldset class="column">
    <legend>Gesprächsziele</legend>
    <p class="muted">
      {{ satisfiedCanvassTargetIds.length }} von
      {{ canvassTargets.length }} Zielen erreicht!
    </p>
    <label
      v-for="canvassTarget in canvassTargets"
      :key="canvassTarget.id"
      :for="`canvass-target-${canvassTarget.id}`"
    >
      <span>{{ canvassTarget.description }}</span>
      <input
        :id="`canvass-target-${canvassTarget.id}`"
        type="checkbox"
        :checked="canvassTargetIsSatisfied(canvassTarget.id)"
        @change="toggleSatisfiedCanvassTarget(canvassTarget.id)"
      />
    </label>
  </fieldset>
</template>
<style scoped>
label {
  display: flex;
  gap: var(--spacing-xs);

  > span {
    flex-grow: 1;
    padding: var(--spacing-xs);
    border-radius: var(--border-radius-badge);
    background-color: var(--bg-color-badge);
  }
}
</style>
